import { render, staticRenderFns } from "./MailingView.vue?vue&type=template&id=2f962756"
import script from "./MailingView.ts?vue&type=script&lang=ts&external"
export * from "./MailingView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports